import { render, staticRenderFns } from "./InventoryContacts.vue?vue&type=template&id=15dd18f9&scoped=true"
import script from "./InventoryContacts.vue?vue&type=script&lang=js"
export * from "./InventoryContacts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15dd18f9",
  null
  
)

export default component.exports